import React from 'react';
import { Link } from 'react-router-dom';
import Modal from './ui/Modal';
import { RATE_LIMIT_EXCEEDED_EVENT } from '../utils/rateLimit';

export default function RateLimitExceededModal() {
  const [open, setOpen] = React.useState(false);
  const [message, setMessage] = React.useState('');

  React.useEffect(() => {
    const handler = (e: Event) => {
      const ev = e as CustomEvent<{ message?: string }>;
      setMessage(ev.detail?.message || 'Upload limit exceeded for this period.');
      setOpen(true);
    };
    window.addEventListener(RATE_LIMIT_EXCEEDED_EVENT, handler);
    return () => window.removeEventListener(RATE_LIMIT_EXCEEDED_EVENT, handler);
  }, []);

  return (
    <Modal isOpen={open} onClose={() => setOpen(false)} title="Limit exceeded" maxWidth="md">
      <div className="space-y-4">
        <p className="text-gray-700">{message}</p>
        <p className="text-gray-600 text-sm">
          To upload more files, upgrade your plan or get in touch with us.
        </p>
        <div className="flex flex-wrap gap-3 pt-2">
          <Link
            to="/pricing"
            onClick={() => setOpen(false)}
            className="inline-flex items-center px-4 py-2 rounded-md text-sm font-medium text-white bg-primary-600 hover:bg-primary-700"
          >
            View plans
          </Link>
          <Link
            to="/contact"
            onClick={() => setOpen(false)}
            className="inline-flex items-center px-4 py-2 rounded-md text-sm font-medium text-primary-600 bg-primary-50 hover:bg-primary-100"
          >
            Contact us
          </Link>
        </div>
      </div>
    </Modal>
  );
}
